import script from "./SkillsEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./SkillsEditor.vue?vue&type=script&setup=true&lang=js"

import "./SkillsEditor.vue?vue&type=style&index=0&id=4221f23b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4221f23b"]])

export default __exports__